module.exports = __webpack_public_path__ + "static/icon2bueno-ae72ddc4ba67c69c3589a425ce731d41.png";